// The login page is served by the user-dashboard app, so it needs a full page load
// (a router navigation would render the legacy copy of the page instead).
export function getLoginPageUrl (query = {}) {
  const params = new URLSearchParams(query).toString()

  return params ? `/auth/login?${params}` : '/auth/login'
}

export default function redirectToLoginPage (query = {}) {
  window.location.href = getLoginPageUrl(query)
}
